import React, { useEffect, useState } from 'react';

import { Checkbox, Form, Input, Select, Tag, Tooltip } from 'antd';
import { ChevronDown, ChevronUp, CloseIcon, Information } from '../../assets/icons';
import FloatingLabel from '../../components/FloatingLabel/FloatingLabel';
import { getUsCurrencyFormat } from '../../utils/usCurrencyFormatter';

const BuyOrder = React.forwardRef((props, ref) => {
  const {
    numberOfShare,
    isMaxRangeError,
    sharesRemainingToPurchase,
    setNumberOfShare,
    limitPrice,
    setLimitPrice,
    LowestAskPrice,
    quickBuyPropertyData,
    duration,
    setDuration,
    totalInvestment,
    transactionFee,
    totalPurchase,
    partialFills,
    setPartialFills,
  } = props;
  const [arrowUpDuration, setArrowUpDuration] = useState(false);
  const [expandAdvanced, setExpandAdvanced] = useState(true);
  const [durationInfo, setDurationInfo] = useState(true);
  const [isTextSelected, setIsTextSelected] = useState(false);

  useEffect(() => {
    setLimitPrice('');
  }, []);

  return (
    <div className='buy-content'>
      <Form ref={ref} form={ref?.current}>
        <FloatingLabel label='Number of shares' inputId='shares' inputValue={numberOfShare} alwaysBig>
          <Form.Item
            className='mb-12 mt-42'
            validateStatus={numberOfShare && (isMaxRangeError || numberOfShare <= 0 || Number(numberOfShare) % 1 !== 0) && 'error'}
            help={
              numberOfShare &&
              (numberOfShare <= 0 || isMaxRangeError || Number(numberOfShare) % 1 !== 0) &&
              (Number(numberOfShare) % 1 !== 0
                ? 'Decimal numbers are not allowed.'
                : numberOfShare <= 0
                ? 'Please enter a number of share grater then 0.'
                : 'You have exceeded the Buy out limit.(i.e more than 9.8%).')
            }
          >
            <Input
              value={numberOfShare}
              onChange={(e) => setNumberOfShare(e.target.value.replace(/[^0-9]/g, ''))}
              onSelect={(e) => {
                window.getSelection().toString().length > 0 ? setIsTextSelected(true) : setIsTextSelected(false);
              }}
              onKeyPress={(event) => {
                if ((!/[0-9]/.test(event.key) || Number(event.target.value) > Number(sharesRemainingToPurchase?.toFixed(0))) && !isTextSelected) {
                  event.preventDefault();
                }
              }}
              id='share'
              type='number'
              onWheel={(e) => {
                e.target.blur();
              }}
              controls={false}
            />
          </Form.Item>
        </FloatingLabel>
        <div className='mb-30 buy-tags'>
          {/* <Tag
          className={
            numberOfShare?.toString() === minButtonValue.toString() &&
            "ant-tag__selected"
          }
          onClick={() => setNumberOfShare(minButtonValue.toString())}
        >
          {`min: ${minButtonValue.toString()}`}
        </Tag> */}
          <Tag
            className={
              Number(sharesRemainingToPurchase.toFixed(0)) < 100 ? 'ant-tag-disabled' : numberOfShare?.toString() === '100' && 'ant-tag__selected'
            }
            onClick={() => Number(sharesRemainingToPurchase.toFixed(0)) >= 100 && setNumberOfShare('100')}
          >
            most popular: 100
          </Tag>
          <Tag
            className={numberOfShare?.toString() === sharesRemainingToPurchase.toFixed(0).toString() && 'ant-tag__selected'}
            onClick={() => setNumberOfShare(sharesRemainingToPurchase.toFixed(0).toString() || '0')}
          >
            {`max (9.8%): ${getUsCurrencyFormat(sharesRemainingToPurchase.toFixed(0) || 0)}`}
          </Tag>
        </div>
        <FloatingLabel label='Limit price' inputId='shares' inputValue={limitPrice} alwaysBig>
          <Form.Item
            className='mb-12'
            validateStatus={limitPrice && !/^(?!0\d)(\d+(?:\.\d{1,2})?)$/.test(limitPrice) && 'error'}
            help={limitPrice && !/^(?!0\d)(\d+(?:\.\d{1,2})?)$/.test(limitPrice) && 'Please enter a number grater then 0 and upto 2 decimal places.'}
          >
            <Input
              value={limitPrice}
              onChange={(e) => setLimitPrice(e.target.value)}
              placeholder='$'
              onKeyPress={(event) => {
                if (!/[0-9 .]/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                  event.preventDefault();
                }
              }}
              id='limit'
            />
          </Form.Item>
        </FloatingLabel>
        <div className='mb-30 buy-tags'>
          <Tag
            className={
              Number(LowestAskPrice) <= 0 ? 'ant-tag-disabled' : limitPrice?.toString() === LowestAskPrice?.toString() && 'ant-tag__selected'
            }
            onClick={() => Number(LowestAskPrice) > 0 && setLimitPrice(LowestAskPrice?.toString() || '0')}
          >
            {`Best ask: $${getUsCurrencyFormat(LowestAskPrice || 0)} `}
          </Tag>
          <Tag
            className={limitPrice?.toString() === quickBuyPropertyData?.lastTradedPrice?.toString() && 'ant-tag__selected'}
            onClick={() => setLimitPrice(quickBuyPropertyData?.lastTradedPrice?.toString() || '0')}
          >
            {`Last price: $${getUsCurrencyFormat(quickBuyPropertyData?.lastTradedPrice || 0)}`}
          </Tag>
        </div>
        <FloatingLabel label='Duration' inputId='duration' inputValue={duration} alwaysBig>
          <>
            {/* <div id='duration-anchor' /> */}
            <Form.Item className='mb-8' name='duration'>
              <Select
                id='duration'
                popupClassName='filter-select-dropdown'
                onChange={(value) => setDuration(value)}
                value={duration}
                defaultValue={duration}
                // getPopupContainer={() => document.getElementById('duration-anchor')}
                onDropdownVisibleChange={() => setArrowUpDuration(!arrowUpDuration)}
                suffixIcon={arrowUpDuration ? <ChevronUp color='#1A1519' /> : <ChevronDown color='#1A1519' />}
              >
                <Select.Option value='Good Until Cancel'>Good until cancel</Select.Option>
                <Select.Option value='Good For The Day'>Good for the day</Select.Option>
              </Select>
            </Form.Item>
          </>
        </FloatingLabel>
        {durationInfo && (
          <div className='d-flex py-8 px-12 fz-12 bg-parchment radius-4 g-16 mb-24'>
            <div>
              <p>
                A “good until cancel” order is a buy or sell order that remains active until it is either executed or until the investor cancels it.
              </p>
              <p className='mb-0'>
                A “good for the day” order is a buy or sell order that is only good for the remainder of the trading day on which it is placed. All
                “good for the day” orders will expire at 11:59 PM EST on the day they were placed.
              </p>
            </div>
            <div className='no-shrink cursor-pointer' onClick={() => setDurationInfo(false)}>
              <CloseIcon size={16} color='#726460' />
            </div>
          </div>
        )}
        <div className='mb-0 basic-info'>
          <div className='mb-24 basic-info'>
            <div className='basic-info__item'>
              <span className='basic-info__item__name'>Total investment (USD)</span>
              <span className='basic-info__item__value fw-600'>{`$${getUsCurrencyFormat(totalInvestment || 0)}`}</span>
            </div>
            <div className='basic-info__item'>
              <span className='basic-info__item__name'>Platform fee</span>
              <span className='basic-info__item__value'>$2.50</span>
            </div>
            <div className='basic-info__item'>
              <span className='basic-info__item__name'>Broker-Dealer/ATS Fee (1%)</span>
              <span className='basic-info__item__value'> {`$${transactionFee || ''}`}</span>
            </div>
            <div className='basic-info__item'>
              <span className='basic-info__item__name'>Total purchase (USD)</span>
              <span className='basic-info__item__value fw-600'>{`$${totalPurchase || ''}`}</span>
            </div>
          </div>
        </div>
        <div className='mb-40 fz-16'>
          <p className='fw-600 mb-8 cursor-pointer' onClick={() => setExpandAdvanced(!expandAdvanced)}>
            Advanced {expandAdvanced ? <ChevronUp verticalAlign='-7px' /> : <ChevronDown verticalAlign='-7px' />}
          </p>
          {!!expandAdvanced && (
            <div className='options'>
              <Checkbox checked={partialFills} onChange={(e) => setPartialFills(e.target.checked)} className='fz-16'>
                Accept partial fills
                <Tooltip
                  popupClassName='div-yeild-pop'
                  title='Allow for your order to be filled in segments by smaller buyers. Doing this will give you the ability to start trading owned shares right away. Unfilled shares will be cancelled at the selected duration. '
                  trigger='hover'
                >
                  <span>
                    <Information className='cursor-pointer' marginLeft='4px' verticalAlign='sub' color='#1A1519' />
                  </span>
                </Tooltip>
              </Checkbox>
            </div>
          )}
        </div>
      </Form>
    </div>
  );
});

export default BuyOrder;
